import TableSimple from "ds/components/TableSimple";
import useAnalytics from "hooks/useAnalytics";
import useTableSort from "components/Table/useTableSort";
import { SearchQueryOrderDirection } from "types/generated";
import { EmptystateSearchNoResultsColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";

import { useIdpGroupTableStore } from "./useIdpGroupTableStore";
import { IDP_GROUP_COLUMN_ID, SORT_CONFIG } from "./constants";
import { ManagedUserGroupView } from "../types";
import { IDP_GROUP_TABLE_CELLS } from "./Cells";
import { IdpGroupFilterItemKeys, FILTERS_ORDER_SETTINGS_KEY } from "../constants";
import { useFilteredEntities } from "./useFilteredEntities";

type IdpGroupMappingTableProps = {
  groups: ManagedUserGroupView[];
  loadingContent?: boolean;
};

const IdpGroupMappingTable = ({ groups, loadingContent }: IdpGroupMappingTableProps) => {
  const trackAnalytics = useAnalytics();

  const { sortDescriptor } = useTableSort({
    filtersOrderSettingsKey: FILTERS_ORDER_SETTINGS_KEY,
    sortConfig: SORT_CONFIG,
    initialSortOption: SORT_CONFIG[IDP_GROUP_COLUMN_ID.GROUP_ID] as IdpGroupFilterItemKeys,
    initialSortDirection: SearchQueryOrderDirection.Asc,
  });

  const sortedGroups = useFilteredEntities(groups, sortDescriptor);

  if (sortedGroups.length === 0 && !loadingContent && groups.length) {
    return <EmptyState title="No results" icon={EmptystateSearchNoResultsColored} announce />;
  }

  return (
    <TableSimple
      data={sortedGroups}
      store={useIdpGroupTableStore}
      loading={loadingContent}
      cellPerColumn={IDP_GROUP_TABLE_CELLS}
      rowsPerPage={groups.length || 10}
      ariaLabel="Identity Provider Group Mapping table"
      hasPagination={false}
      filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
      sortConfig={SORT_CONFIG}
      trackAnalytics={trackAnalytics}
    />
  );
};

export default IdpGroupMappingTable;
